import { SuggestionKind } from 'owa-search-service';

export const DEBOUNCE_DELAY_MS = 150;

export type SupportedFilesHubSuggestionKindType =
    | SuggestionKind.Files
    | SuggestionKind.People
    | SuggestionKind.Keywords;

export const SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
];
export const ALL_SUGGESTION_KINDS_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
    SuggestionKind.Message,
    SuggestionKind.Category,
    SuggestionKind.Event,
];

export const ADVANCED_SEARCH_BREAKPOINT = 460;
export const AND_SEPARATOR = ' AND ';
export const CATEGORY_SEARCH_QUERY_PREFIX = 'category:';
export const FILTERS_BUTTON_ID = 'filtersButtonId';
export const FROM_PREFIX = 'From:{0}';
export const HIGHLIGHT_REGEX = /[\ue000\ue001]/g;
export const IS_CATEGORY_QUERY_REGEX = /(category:)/gi;
export const IS_TO_OR_FROM_QUERY_REGEX = /((To:)|(From:))/gi;
export const MAX_CATEGORY_SUGGESTIONS_TO_SHOW = 1;
export const MAX_SERVER_SUGGESTION_OF_KIND = 3;
export const OR_SEPARATOR = ' OR ';
export const PARENTHESIS_FORMAT_STRING = '({0})';
export const QUERY_LENGTH_FOR_CONFIDENCE = 3;
export const SPACE = ' ';
export const TO_PREFIX = 'To:{0}';
